import * as React from "react";

import { Defaults } from "@common/_constants";

interface ErrorProps {
    show: boolean
    title?: string
    description?: string
};


export class Error extends React.PureComponent<ErrorProps> {
    render() {
        const { show, title } = this.props;
        const description = this.props.description || Defaults.FormInvalidMessage;

        return show ? (
            <div
                ref={el => {
                    if (el && el.parentElement) el.parentElement.scrollIntoView();
                }}
                className="c-error">
                {title && <div className="c-error__title">{title}</div>}
                <div className="c-error__desc" data-cy="error-alert" dangerouslySetInnerHTML={{ __html: description }} />
            </div>
        ) : null;
    }
}

export default Error;
